export default __webpack_public_path__ + "static/media/dummylitenshortimg.7e33ad9a932b196ad491a7378981113f.jpg";